import React, { Suspense, useEffect, useState } from 'react'
import Navbar from './components/Navbar'
import { ThemeProvider } from './context/ThemeContext'
import localData from './data/myprofile.json'
import AIChatWidget from './components/AIChatWidget'
import AIPageAnalyzer from './components/AIPageAnalyzer'
import ErrorBoundary from './components/ErrorBoundary'

// Lazy-loaded sections
const Home = React.lazy(() => import('./components/Home'))
const Works = React.lazy(() => import('./components/Works'))
const Skills = React.lazy(() => import('./components/Skills'))
const Contact = React.lazy(() => import('./components/Contact'))
const Footer = React.lazy(() => import('./components/Footer'))

// Minimal skeleton shown while sections hydrate
const SectionSkeleton = () => (
  <div className='section-padding'>
    <div className='max-content flex flex-col gap-4'>
      <div
        className='h-4 w-24 rounded-full animate-pulse'
        style={{ background: 'var(--border-subtle)' }}
      />
      <div
        className='h-8 w-56 rounded-lg animate-pulse'
        style={{ background: 'var(--border-subtle)' }}
      />
      <div
        className='h-4 w-full max-w-md rounded animate-pulse'
        style={{ background: 'var(--border-subtle)' }}
      />
    </div>
  </div>
)

function App() {
  const [data, setData] = useState([])

  useEffect(() => {
    setData(localData.portfolio)
  }, [])

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <div
          style={{
            background: 'var(--bg-base)',
            minHeight: '100vh',
            transition: 'background 0.3s ease'
          }}
        >
          <Navbar />
          <main id='main-content'>
            <Suspense fallback={<SectionSkeleton />}>
              <Home content={data[0]} />
              <Works content={data[1]} />
              <Skills content={data[2]} />
              <Contact />
              <Footer />
            </Suspense>
          </main>

          {/* AI Chat — visible to all visitors */}
          <AIChatWidget />

          {/* AI Page Analyzer — dev/staging only, stripped from production build */}
          {process.env.NODE_ENV !== 'production' && <AIPageAnalyzer />}
        </div>
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default App
